import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Config from 'app/Config';
import ChevronIcon from './../Images/chevron-left.svg';
import './HeroCarouselCard.scss';

const HeroCarouselCard = ({ card, context }) => {
    const iconUrl = card.icon?.expandedValue?.url ? Config.epiBaseUrl + card.icon.expandedValue.url : null;
    const title = card.title?.value || card.titleText?.value;
    const link = card.link?.value;
    const buttonText = card.buttonText?.value;

    const cardContent = (
        <div className="hero-carousel-card">
            <div className="card-content">
                {title && <span className="card-title">{title}</span>}
                {link && buttonText && (
                    <span className="card-button">
                        {buttonText} <Image src={ChevronIcon} alt={title || ''} />
                    </span>
                )}
            </div>
            {iconUrl && <Image src={iconUrl} alt={title || ''} className="card-icon" />}
        </div>
    );

    // If card has both link and button text, make entire card clickable
    if (link && buttonText) {
        return <a href={link} className="card-link-wrapper">{cardContent}</a>;
    }

    return cardContent;
};

export default HeroCarouselCard;
